import React from "react";
import { motion } from "framer-motion";

export default function UnauthorizedPage() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#0f172a] px-6">
      
      {/* 🌌 Background Glow Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-red-500 opacity-20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-120px] right-[-120px] w-[350px] h-[350px] bg-purple-500 opacity-20 rounded-full blur-3xl"></div>
      </div>

      {/* 🚀 Card */}
      <motion.div
        initial={{ opacity: 0, y: 60, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="relative z-10 w-full max-w-md text-center p-10 rounded-3xl bg-white/5 backdrop-blur-xl border border-white/10 shadow-[0_20px_80px_rgba(0,0,0,0.6)]"
      >
        
        {/* 🔴 Animated Icon */}
        <motion.div
          className="mx-auto mb-8 relative"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 140 }}
        >
          {/* Pulse Glow */}
          <motion.div
            className="absolute inset-0 rounded-full bg-red-500 opacity-20 blur-xl"
            animate={{ scale: [1, 1.4, 1], opacity: [0.2, 0.35, 0.2] }}
            transition={{ duration: 2, repeat: Infinity }}
          />

          <svg width="90" height="90" viewBox="0 0 24 24" fill="none">
            <motion.circle
              cx="12"
              cy="12"
              r="10"
              stroke="#ef4444"
              strokeWidth="2.5"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.8 }}
            />
            <motion.line
              x1="8"
              y1="8"
              x2="16"
              y2="16"
              stroke="#ef4444"
              strokeWidth="2.5"
              strokeLinecap="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            />
            <motion.line
              x1="16"
              y1="8"
              x2="8"
              y2="16"
              stroke="#ef4444"
              strokeWidth="2.5"
              strokeLinecap="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            />
          </svg>
        </motion.div>

        {/* 🧠 Title */}
        <motion.h1
          className="text-3xl font-semibold text-white mb-3 tracking-tight"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          Session Expired
        </motion.h1>

        {/* 📄 Description */}
        <motion.p
          className="text-gray-400 text-sm leading-relaxed mb-8"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          We couldn’t verify your session.
          <br />
          Please reopen the app from Wix to continue.<br />
		  If the issue persists, try reinstalling the app.
        </motion.p>

      </motion.div>
    </div>
  );
}